var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { StyleSheet } from 'react-native';
export var getCircularProgressConfig = props => {
  var _a, _b;
  var config = props.config,
    size = props.size,
    value = props.value,
    backgroundColor = props.backgroundColor,
    progressColor = props.progressColor,
    progressBackgroundColor = props.progressBackgroundColor,
    testID = props.testID,
    customSize = props.customSize,
    restProps = __rest(props, ["config", "size", "value", "backgroundColor", "progressColor", "progressBackgroundColor", "testID", "customSize"]);
  var _size = size || 'md';
  var _ref = ((_b = (_a = config === null || config === void 0 ? void 0 : config.size) === null || _a === void 0 ? void 0 : _a[_size]) === null || _b === void 0 ? void 0 : _b.circular) || {},
    progressSize = _ref.progressSize,
    thickness = _ref.thickness;
  if (customSize > 0) {
    var customThickness = customSize * 0.1;
    progressSize = customSize;
    thickness = customThickness;
  }
  var radius = (progressSize - thickness) / 2;
  var circum = radius * Math.PI * 2;
  var svgProgress = 100 - value;
  var cSize = progressSize / 2;
  var circleProps = {
    fill: backgroundColor || 'none',
    cx: cSize,
    cy: cSize,
    r: radius,
    strokeWidth: thickness
  };
  return Object.assign({
    size: progressSize,
    circum,
    svgProgress,
    cSize,
    circleProps,
    backgroundColor,
    progressColor,
    progressBackgroundColor,
    testID
  }, restProps);
};
export var getProgressStyles = () => {
  return StyleSheet.create({
    container: {
      alignItems: 'center',
      justifyContent: 'center'
    }
  });
};